var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    zoomAndPan: "magnify",
    viewBox: "0 0 150 187.499995",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a6f32bccd2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.199219 14.03125 L 149.800781 14.03125 L 149.800781 172.609375 L 0.199219 172.609375 Z M 0.199219 14.03125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a6f32bccd2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M 0.199219 14.066406 L 101.980469 14.066406 L 101.980469 84.808594 L 48.167969 84.808594 L 48.167969 38.765625 L 27.515625 38.765625 L 27.515625 147.875 L 48.167969 147.875 L 48.167969 103.859375 L 101.980469 103.859375 L 101.980469 147.875 L 122.476562 147.875 L 122.476562 14.066406 L 149.800781 14.066406 L 149.800781 172.570312 L 0.199219 172.570312 Z M 0.199219 14.066406 ",
    fillOpacity: 1,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHLetter);
export default __webpack_public_path__ + "static/media/h-letter.1222c5a3174b2385115ab9b49b09474b.svg";
export { ForwardRef as ReactComponent };